import { asyncAction, action } from '../../utils/actions';

export const fetchDevices = asyncAction('devices/FETCH_DEVICES');
export const fetchDevice = asyncAction('devices/FETCH_DEVICE');
export const updateFormula = action('devices/UPDATE_FORMULA');
export const updateTarget = action('devices/UPDATE_TARGET');
export const updateGroup = action('devices/UPDATE_GROUP');
export const updateDevice = asyncAction('devices/UPDATE_DEVICE');
